
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs,
              ...rest,
            },
            children.concat([_c('g',{staticClass:"ql-fill ql-color-label"},[_c('path',{attrs:{"d":"M6 6.868V6H5v1h.942L6 6.868zM4 4h1v1H4zM6.817 5H6v1h.38l.437-1zM2 6h1v1H2zM3 5h1v1H3zM4 7h1v1H4zM4 11.439V11H3v1h.755L4 11.439zM2 12h1v1H2zM2 9h1v1H2zM2 15h1v1H2zM4.63 10H4v1h.192l.438-1zM3 8h1v1H3zM10.832 4.2l.168.382V4h-.292a1.948 1.948 0 01.124.2zM7 4.582l.168-.382a1.929 1.929 0 01.124-.2H7v.582zM8 13h-.317l-.351.8a1.933 1.933 0 01-.124.2H8v-1zM12 2h1v1h-1zM11 3h1v1h-1zM9 3H8v.282A1.985 1.985 0 019 3zM2 3h1v1H2zM6 2h1v1H6zM3 2h1v1H3zM5 3h1v1H5zM9 2h1v1H9zM15 14h1v1h-1zM13.447 10.174l.022.051.003.007.336.768H14v-1h-.63l.077.174zM13 7h1v1h-1zM15 5h1v1h-1zM14 6h1v1h-1zM15 8h1v1h-1zM14 9h1v1h-1zM3.775 14H3v1h1v-.686A1.97 1.97 0 013.775 14zM14 3h1v1h-1zM12 6.868V6h-.38l.38.868zM15 2h1v1h-1zM12 5h1v1h-1zM13 4h1v1h-1zM12.933 9H13V8h-.505l.438 1zM9 14h1v1H9zM8 15h1v1H8zM6 14.926V15h1v-.684a1.993 1.993 0 01-1 .61zM5 15h1v1H5zM10.668 13.8l-.351-.8H10v1h.792a1.947 1.947 0 01-.124-.2zM11 15h1v1h-1zM14.332 12.2a1.99 1.99 0 01.166.8H15v-1h-.755zM14 15h1v1h-1zM15 11h1v1h-1z"}})]),_c('path',{staticClass:"ql-stroke",attrs:{"d":"M5.5 13L9 5l3.5 8M11.63 11H6.38"}})])
          )
        }
      }
    